import { combineReducers } from 'redux';
import onboarderReducer from "./onboarderReducer"
import userReducer from "./userReducer"
import otherReducer from "./otherReducer"
const rootReducer = combineReducers({
    onboard:onboarderReducer,
    user:userReducer,
    other:otherReducer
});

export default rootReducer;